import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { selectToken } from '@caudena/web-platform/dist/tokens/utils/selectToken'
import { createTokenKey } from '@caudena/web-platform/dist/tokens/utils/createTokenKey'
import { SurfaceContainer } from '@caudena/web-platform'
import { shouldForwardProp } from '../../emotion'

export const RightOverlapSidebarWrapper = styled('div', { shouldForwardProp })<{
  $isOpen: boolean
  $width: string
}>`
  @starting-style {
    opacity: 0;
    transform: translateX(100%);
  }
  position: fixed;
  height: 100%;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1001;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '100%')});
  width: ${({ $width }) => $width};
  transition: all 0.25s;
  transition-behavior: allow-discrete;
`
export const RightOverlapSidebar = styled(SurfaceContainer)`
  ${({ theme }) =>
    css({
      backgroundColor: selectToken(theme, createTokenKey(['white'])),
      borderLeft: `1px solid ${selectToken(
        theme,
        createTokenKey(['grey500'])
      )}`,
      width: '100%',
      minHeight: '100vh',
      overflow: 'auto',
    })}
`
